import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import {
  Box,
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Search from "../../components/Search";
import UserAvatar from "../../components/UserAvatar";
import { useUserData } from "../../user";
import { useLocalState } from "../../utils/hooks/global/useLocalStorage";

const Topbar = ({ onMenuClick }) => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const [jwt, setJwt] = useLocalState(null, "jwt");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const user = useUserData();

  const handleClose = () => {
    setAnchorEl(null);
  };

  const goToProfile = () => {
    handleClose();
    navigate("/profile");
  };

  const handleLogout = () => {
    handleClose();
    fetch(`${backendUrl}/users/logout`, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + jwt,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setJwt(null);
        window.location.reload();
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  return (
    <Box
      component="header"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: { xs: 1, sm: 2 },
        height: 64,
        px: { xs: 1.5, sm: 3 },
        position: "sticky",
        top: 0,
        zIndex: 1100,
        backgroundColor: "rgba(252, 252, 252, 0.9)",
        backdropFilter: "blur(6px)",
        borderBottom: "1px solid #e3e5e9",
        mb: { xs: 2, sm: 3 },
      }}
    >
      <IconButton
        onClick={onMenuClick}
        aria-label="Open menu"
        sx={{ display: { md: "none" } }}
      >
        <MenuRoundedIcon />
      </IconButton>

      <Box sx={{ flex: 1, minWidth: 0, maxWidth: 420 }}>
        <Search />
      </Box>

      <Box sx={{ flex: { xs: 0, sm: 1 } }} />

      <Tooltip title="Account">
        <IconButton
          onClick={(event) => setAnchorEl(event.currentTarget)}
          aria-label="Account menu"
          aria-controls={open ? "account-menu" : undefined}
          aria-haspopup="true"
          sx={{ p: 0.5 }}
        >
          <UserAvatar name={user?.displayName} />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        PaperProps={{
          elevation: 0,
          sx: {
            mt: 1,
            minWidth: 220,
            borderRadius: "12px",
            border: "1px solid #e3e5e9",
            boxShadow:
              "rgba(145, 158, 171, 0.2) 0px 0px 2px 0px, rgba(145, 158, 171, 0.12) 0px 12px 24px -4px",
          },
        }}
      >
        <Box sx={{ px: 2, py: 1.5 }}>
          <Typography sx={{ fontWeight: 600, fontSize: 14 }} noWrap>
            {user?.displayName}
          </Typography>
          <Typography sx={{ color: "#637381", fontSize: 13 }} noWrap>
            {user?.email}
          </Typography>
        </Box>
        <Divider />
        <MenuItem onClick={goToProfile} sx={{ py: 1.25 }}>
          <ListItemIcon>
            <PersonOutlinedIcon fontSize="small" />
          </ListItemIcon>
          Profile
        </MenuItem>
        <MenuItem onClick={handleLogout} sx={{ py: 1.25 }}>
          <ListItemIcon>
            <LogoutOutlinedIcon fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default Topbar;
